import React from "react";
import {useDispatch, useSelector} from "react-redux";
import Notice from "../Notice";
import SaveButtons from "../SaveButtons";
import {setQuantity} from "../../store/details/projectDetailsSlice";
import QuickshipDisplay from "../common_elements/QuickshipDisplay";
import {displayElementSectionOptions, setDisplayElementOptionsModal} from "../../store/configuratorStateSlice";
import ElementSectionOptionSelectionModal from "./ElementSectionOptionSelectionModal";


const ElementSummary = (props) => {
    const shouldDisplay = useSelector(state => state.configuratorStateReducer.displayElementSummary);
    const quantity = useSelector(state => state.projectDetailsReducer.quantity);
    const currency = useSelector(state => state.projectDetailsReducer.currency);
    const projectType = useSelector(state => state.projectDetailsReducer.projectType);
    const sideSections = useSelector( state => state.productElementsReducer.side_sections);
    const shapedAttributes = useSelector(state => state.productSelectionsReducer.shapedAttributes);
    const priceBook = useSelector(state => state.projectDetailsReducer.priceBook);
    const displayElementOptionModal = useSelector(state => state.configuratorStateReducer.uiState.displayElementOptionModal);
    const summary = useSelector(state => state.summaryReducer);
    const dispatch = useDispatch();
    if(!shouldDisplay){
        return null;
    }

    const styles = {
        section: {
            width: '90%',
            display: 'flex',
            marginBottom: '7px'
        },
        divSmall: {
          width: '10%'
        },
        span: {
            padding: 0
        },
        catSpan: {
            padding: '0 5px',
            fontWeight: 900,
        }

    }

    const displayElementCatalogs = () => {
        let content = [];
        const sectionData = summary.sections
        if( sectionData) {
            let elementIndex = 1;
            let sidesDisplaying = [];
            for( const summaryRow of sectionData) {
                let sectionContent = [];

                let sideDisplayContent = [];
                // handle displaying sides for line shape
                let matchingSide = Object.keys(sideSections).find(key => sideSections[key].includes(summaryRow.section_number));
                if( matchingSide && !sidesDisplaying.includes(matchingSide) && matchingSide != 0) {
                    sidesDisplaying.push(matchingSide);
                    const classes = matchingSide == 1 ? "element-side-group-first" : 'element-side-group-start'
                    sideDisplayContent.push(
                        <div className={classes} style={{width: '10%', marginTop: '0'}}>
                            <h5>Side {matchingSide}</h5>
                        </div>
                    )
                }
                else if(shapedAttributes.length === 0){
                    sideDisplayContent.push(<></>);
                }else {
                    const classes = summaryRow.section_number == 0 ? 'element-side-group-start' : ""
                    sideDisplayContent.push(<div className={classes} style={{width: '10%'}}></div>);
                }

                // Display Section number
                for(const element of summaryRow.elements) {
                    sectionContent.push(
                        <div key={`section-${summaryRow.section_number}-${elementIndex}`}>
                            <span style={styles.span}>{elementIndex}.</span>
                            <span style={styles.catSpan}>{element.element_cat}</span>
                            <span style={styles.span}>- {element.catalog_number}</span>
                        </div>
                    )
                    elementIndex++;
                }
                content.push(
                    <div style={{display: 'flex', width: '100%'}}>
                        { sideDisplayContent }
                        <div key={`${summaryRow.section_number}-wrapper`} style={styles.section}>
                            <div style={styles.divSmall}>{displaySectionTitle(summaryRow.section_number)}</div>
                            <div style={styles.divSmall}>{asPrice(summaryRow.section_total)}</div>
                            <div>
                                { sectionContent }
                            </div>
                            { displayModuleSelection(summaryRow.section_number) }
                        </div>
                    </div>
                )
            }
        }

        return content;
    }

    const displayModuleSelection = (section_number) => {
        if(shapedAttributes.length > 0){
            return(
                <div>
                    <span style={{cursor: 'pointer'}} onClick={() => dispatch(displayElementSectionOptions(section_number))}>Edit Options</span>
                </div>
            )
        } else {
            return null
        }

    }

    const displaySectionTitle = (sectionNumber) => {
        const label = sectionNumber === 0 || sectionNumber === 'no-section' ? "Connectors:" : `Section ${sectionNumber}:`
        return (
            <>{label}</>
        )
    }

    const asPrice = (value) => {
        return `${currency} ${(parseFloat(value)).toFixed(2)}`
    }
    const handleFormChange = (event) => {
        dispatch(setQuantity(event.target.value));
    }

    const getQuantity = () => {
        if(quantity == null ){
            return;
        }
        return <input min="1" max="99999" style={{width: '6em'}} defaultValue={quantity} type="number" onChange={(e) => handleFormChange(e)} />
    }

    return (
        <div className="summary-wrapper">
            <div className="summary" id="summary-panel">
                <div className="panel">
                    <div className="row">
                        <div className="small-12 columns summary-title less-margin">
                            <h2>Summary - { projectType } </h2>
                        </div>
                    </div>
                    <div className="row">
                        <Notice addPadding={true}/>
                        <div className="small-12 columns no-padding" >
                            <p className={'no-border-top'}>Catalog Number:
                                <span style={{'marginLeft': '0.2em'}}>
                                    { summary.catalog_number}
                                </span>
                            </p>
                            <div className="p add-yellow no-border-top">
                                Sections & Elements
                                <div>
                                    { displayElementCatalogs() }
                                </div>
                            </div>
                            <p className={"no-border less-padding top-padding"}>
                                <div className='row'>
                                    <div className="small-6 columns no-padding">
                                        Unit Price:
                                        <span style={{'marginLeft': '0.2em'}}>
                                            {currency} {summary.price}
                                        </span>
                                    </div>
                                    <div className="small-6 columns no-padding">Price Book:
                                        <span style={{'marginLeft': '0.2em'}}>
                                            {priceBook}
                                        </span>
                                    </div>
                                </div>
                            </p>

                            <p className="no-border less-padding">
                                <label> Quantity: </label>
                                {getQuantity()}
                            </p>

                            <p className="total-text no-border less-padding">Total:
                                <span style={{'marginLeft': '0.2em'}}>
                                    {currency + ' ' + summary.total_price}
                                </span>
                            </p>
                            <QuickshipDisplay />
                        </div>
                    </div>
                    <div className="row">
                        <SaveButtons />
                    </div>
                </div>
            </div>
            { displayElementOptionModal ? <ElementSectionOptionSelectionModal elementSummary={summary}/> : null }
        </div>
    )
}

export default ElementSummary;